export default "<div class=\"matero-progress-bar\"\n     [ngStyle]=\"{ 'width.%': value, 'background-color': foreground }\">\n</div>"